import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthCredentials } from '../models/auth-credentials.model';
import { UserModel } from '../models/user.model';

export const authActions = createActionGroup({
    source: 'Auth',
    events: {
        'Set ReturnUrl': props<{ returnUrl: string }>(),
        'Interrupt Login': props<{ fullAuthRequired: boolean }>(),
        'Interrupt Login On First Route': props<{ fullAuthRequired: boolean }>(),
        Login: props<{ credentials: AuthCredentials; impersonateAs: string }>(),
        'Login Succeeded': props<{ user: UserModel; impersonateAs: string }>(),
        'Login Failed': props<{ error: any }>(),
        Logout: props<{ targetPath?: string }>(),
        'Logout Succeeded': props<{ targetPath?: string }>(),
        'Logout Failed': props<{ error: any }>(),
        Autologin: emptyProps(),
        'Autologin Succeeded': props<{ user: UserModel; isSemiAuth: boolean }>(),
        'Autologin Failed': props<{ error: any }>(),
        'Autologin Cancelled': emptyProps(),
        Impersonate: props<{ impersonatedUserId: string }>(),
        'Impersonate Succeeded': props<{ user: UserModel }>(),
        'Impersonate Failed': props<{ error: any }>(),
        'Skip Impersonation': emptyProps()
    }
});
